<template>
  <div>
    <slot />
  </div>
</template>
<script>
export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    visible(isVisible) {
      if (isVisible) {
        document.documentElement.classList.add('overflow-y-hidden');
        window.addEventListener('wheel', this.handleWheel, { passive: false });
      } else {
        document.documentElement.classList.remove('overflow-y-hidden');
        setTimeout(() => window.removeEventListener('wheel', this.handleWheel), 1000);
      }
    },
  },
  methods: {
    handleWheel(e) {
      e.stopImmediatePropagation();
    },
  },
};
</script>
